import { useEffect, useState } from 'react'

const CONSENT_KEY = 'fukodrom_cookie_consent'
export type ConsentState = 'accepted' | 'essential'

export function getStoredConsent(): ConsentState | null {
  if (typeof window === 'undefined') return null
  const value = window.localStorage.getItem(CONSENT_KEY)
  return value === 'accepted' || value === 'essential' ? value : null
}

export function CookieBanner() {
  const [consent, setConsent] = useState<ConsentState | null>(null)

  useEffect(() => {
    setConsent(getStoredConsent())
  }, [])

  if (consent) return null

  const persist = (value: ConsentState) => {
    window.localStorage.setItem(CONSENT_KEY, value)
    window.dispatchEvent(new CustomEvent('fukodrom:consent-changed', { detail: value }))
    setConsent(value)
  }

  return (
    <div className="fixed inset-x-4 bottom-4 z-[1000] md:inset-x-auto md:bottom-6 md:right-6 md:max-w-md">
      <div className="rounded-[24px] border border-slate-200 bg-white/95 p-4 shadow-[0_20px_60px_rgba(15,23,42,0.18)] backdrop-blur md:p-5">
        <div className="space-y-3 text-sm text-slate-700">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-emerald-700">
              Piškotki in analitika
            </p>
            <p className="mt-2 leading-6">
              Nujne piškotke uporabljamo za prijavo in varnost. Z dovoljenjem vključimo še
              first-party analitiko za izboljšanje onboarding flowa, iskanja in aktivacije.
            </p>
            <p className="text-xs leading-5 text-slate-500">
              Več podrobnosti je v <a href="/privacy" className="font-semibold text-emerald-700">Politiki zasebnosti</a>.
            </p>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={() => persist('essential')}
              className="rounded-full border border-slate-300 px-4 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              Samo nujni
            </button>
            <button
              type="button"
              onClick={() => persist('accepted')}
              className="rounded-full bg-emerald-700 px-4 py-2.5 font-semibold text-white transition hover:bg-emerald-800"
            >
              Dovoli analitiko
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
